import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="bg-gray-900 text-white py-12 lg:py-16">
            <div className="container mx-auto px-4 lg:px-8">
                <div className="text-center mb-8">
                    <h3 className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent mb-4">
                        STUDIO
                    </h3>
                    <p className="text-gray-400 max-w-lg mx-auto">
                        Where creativity meets craftsmanship. Follow our journey as we continue to push the boundaries of artistic fashion.
                    </p>
                </div>
                <div className="flex justify-center gap-8 text-sm text-gray-400 mb-8 flex-wrap">
                    <span className="hover:text-orange-400 cursor-pointer transition-colors" onClick={() => navigate('/template20/shop')}>Shop</span>
                    <span className="hover:text-orange-400 cursor-pointer transition-colors" onClick={() => navigate('/template20/contact')}>Contact</span>
                    <span className="hover:text-orange-400 cursor-pointer transition-colors" onClick={() => navigate('/template20/orders')}>Orders</span>
                    <span className="hover:text-orange-400 cursor-pointer transition-colors">Instagram</span>
                    <span className="hover:text-orange-400 cursor-pointer transition-colors">Portfolio</span>
                    <span className="hover:text-orange-400 cursor-pointer transition-colors">Blog</span>
                </div>
                <div className="text-center">
                    <p className="text-xs text-gray-500">&copy; 2025 Studio Creative. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
